import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { Typography } from '@material-ui/core';
import { DelaStarIcon } from '~/modules/common/components/Icons';
import {
  PERIOD_SCALE_ENUM,
  DISPLAY_UNIT_ENUM
} from '~/modules/resourcing/common/enums';
import { ResourceMatchItemAddResourceButton } from './ResourceMatchItemAddResourceButton';
import useStyles from './useStyles';

export const ResourceMatchItemNoMatches = ({
  dataQeId,
  resourceRequest,
  scale,
  displayUnit
}) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const resourceMatchItemNoMatchesDataQeId = dataQeId
    ? `${dataQeId}_ResourceMatchItemNoMatches`
    : undefined;

  return (
    <div
      data-qe-id={resourceMatchItemNoMatchesDataQeId}
      className={classes.itemRoot}
    >
      <div className={classes.itemContainer}>
        <div className={classes.itemTextContainer}>
          <Typography variant="caption" color="textPrimary">
            {formatMessage({
              id: 'resourceMatchItem.resourceMatcher'
            })}
          </Typography>
          <DelaStarIcon className={classes.itemDelaStarIcon} />
        </div>
        <div
          className={classNames(
            classes.itemTextContainer,
            classes.itemNegativeMargin
          )}
        >
          <Typography variant="body2" color="textSecondary">
            {formatMessage({
              id: 'resourceMatchItem.noMatchesFound'
            })}
          </Typography>
        </div>
      </div>
      <div>
        <ResourceMatchItemAddResourceButton
          resourceRequest={resourceRequest}
          scale={scale}
          displayUnit={displayUnit}
        />
      </div>
    </div>
  );
};

ResourceMatchItemNoMatches.propTypes = {
  dataQeId: PropTypes.string,
  resourceRequest: PropTypes.object.isRequired,
  scale: PropTypes.oneOf(Object.values(PERIOD_SCALE_ENUM)),
  displayUnit: PropTypes.oneOf(Object.values(DISPLAY_UNIT_ENUM))
};

export default ResourceMatchItemNoMatches;
